__turbopack_context__.v({
  "canvas": "UxKZAG_canvas",
});
